import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var baseLabel = createRuntimeFn({defaultClassName:'baseLabel_baseLabel__10772fr0',variantClassNames:{state:{'default':'baseLabel_baseLabel_state_default__10772fr1',error:'baseLabel_baseLabel_state_error__10772fr2'},disabled:{true:'baseLabel_baseLabel_disabled_true__10772fr3'},required:{true:'baseLabel_baseLabel_required_true__10772fr4'}},defaultVariants:{state:'default'},compoundVariants:[]});

export { baseLabel };
//# sourceMappingURL=baseLabel.vanilla.mjs.map
